{
  "name": "dls-frontend",
  "version": "1.0.19-20261102-170403",
  "scripts": {
    "ng": "ng",
    "ng-openapi-gen": "ng-openapi-gen",
    "swagger-get-sia:dev": "node generate-api-usage/sia/swagger-get-sia-proxy.js dev",
    "swagger-get-sia:prod": "node generate-api-usage/sia/swagger-get-sia-proxy.js prod",
    "swagger-get-sia:test": "node generate-api-usage/sia/swagger-get-sia-proxy.js test",
    "swagger-get-sia:uat": "node generate-api-usage/sia/swagger-get-sia-proxy.js uat",
    "swagger-get-sia:apitest": "node generate-api-usage/sia/swagger-get-sia-proxy.js apitest",
    "swagger:fetch:dev": "node scripts/fetch-swaggers.js dev",
    "swagger:fetch:test": "node scripts/fetch-swaggers.js test",
    "swagger:fetch:uat": "node scripts/fetch-swaggers.js uat",
    "swagger:fetch:apitest": "node scripts/fetch-swaggers.js apitest",
    "swagger:fetch:prod": "node scripts/fetch-swaggers.js prod",
    "generate:api:sia:dev": "npm run swagger-get-sia:dev && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons-v3.json",
    "generate:api:sia:prod": "npm run swagger-get-sia:prod && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons-v3.json",
    "generate:api:sia:test": "npm run swagger-get-sia:test && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons-v3.json",
    "generate:api:sia:uat": "npm run swagger-get-sia:uat && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons-v3.json",
    "generate:api:sia:apitest": "npm run swagger-get-sia:apitest && ng-openapi-gen -c openapi-configs/openapi-sia-main.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons.json && ng-openapi-gen -c openapi-configs/openapi-sia-main-v3.json && ng-openapi-gen -c openapi-configs/openapi-sia-addons-v3.json",
    "generate:api:dev": "ng-openapi-gen -c openapi-configs/openapi-main.dev.json && ng-openapi-gen -c openapi-configs/openapi-addons.dev.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.dev.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.dev.json",
    "generate:api:prod": "ng-openapi-gen -c openapi-configs/openapi-main.prod.json && ng-openapi-gen -c openapi-configs/openapi-addons.prod.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.prod.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.prod.json",
    "generate:api:uat": "ng-openapi-gen -c openapi-configs/openapi-main.uat.json && ng-openapi-gen -c openapi-configs/openapi-addons.uat.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.uat.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.uat.json",
    "generate:api:test": "ng-openapi-gen -c openapi-configs/openapi-main.test.json && ng-openapi-gen -c openapi-configs/openapi-addons.test.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.test.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.test.json",
    "generate:api:apitest": "ng-openapi-gen -c openapi-configs/openapi-main.apitest.json && ng-openapi-gen -c openapi-configs/openapi-addons.apitest.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.apitest.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.apitest.json",
    "start": "npm run generate:api:dev && ng serve --host=0.0.0.0 --configuration=development",
    "start:dev": "npm run generate:api:dev && ng serve --host=0.0.0.0 --configuration=development",
    "start:prod": "npm run generate:api:prod && ng serve --host=0.0.0.0 --configuration=prod",
    "start:test": "npm run generate:api:test && ng serve --host=0.0.0.0 --configuration=test",
    "start:uat": "npm run generate:api:uat && ng serve --host=0.0.0.0 --configuration=uat",
    "start:apitest": "npm run generate:api:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
    "start:localDev": "npm run generate:api:localDev && ng serve --configuration=localDev",
    "start:sia:dev": "npm run generate:api:sia:dev && ng serve --host=0.0.0.0 --configuration=development",
    "start:sia:prod": "npm run generate:api:sia:prod && ng serve --host=0.0.0.0 --configuration=prod",
    "start:sia:test": "npm run generate:api:sia:test && ng serve --host=0.0.0.0 --configuration=test",
    "start:sia:uat": "npm run generate:api:sia:uat && ng serve --host=0.0.0.0 --configuration=uat",
    "start:sia:apitest": "npm run generate:api:sia:apitest && ng serve --host=0.0.0.0 --configuration=apitest",
    "build": "npm run generate:api:dev && node prebuild.js && ng build",
    "build:prod": "npm run generate:api:prod && node update-version.js && node prebuild.js && ng build --configuration prod",
    "build:uat": "npm run swagger:fetch:uat && npm run generate:api:uat && node update-version.js && node prebuild.js && ng build --configuration uat",
    "build:dev": "npm run swagger:fetch:dev && npm run generate:api:dev && node update-version.js && node prebuild.js && ng build --configuration dev",
    "build:test": "npm run swagger:fetch:test && npm run generate:api:test && node update-version.js && node prebuild.js && ng build --configuration test",
    "build:api-test": "npm run swagger:fetch:apitest && npm run generate:api:apitest && node update-version.js && node prebuild.js && ng build --configuration apitest",
    "generate:api-usage": "cd generate-api-usage && npm i && node index.js",
    "test": "ng test",
    "test:vitest": "node prebuild.js && vitest run --config vitest.config.ts",
    "test:vitest:watch": "node prebuild.js && vitest --config vitest.config.ts",
    "lint": "ng lint",
    "i18n:extract": "ngx-translate-extract -i ./src -o ./src/assets/i18n/de.json -o ./src/assets/i18n/en.json -f namespaced-json -s -n --format-indentation '    '",
    "e2e": "ng e2e",
    "format:write": "prettier --write \"src/**/*{.ts,.json,.css,.scss,.html}\"",
    "generate:api:e2e": "ng-openapi-gen -c openapi-configs/openapi-main.e2e.json && ng-openapi-gen -c openapi-configs/openapi-main-v3.e2e.json && ng-openapi-gen -c openapi-configs/openapi-bff.e2e.json && ng-openapi-gen -c openapi-configs/openapi-addons.e2e.json && ng-openapi-gen -c openapi-configs/openapi-addons-v3.e2e.json",
    "build:e2e": "npm run generate:api:e2e && node prebuild.js && ng build --configuration production",
    "cypress:start": "npm run generate:api:dev && ng serve",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "cypress:wait-on": "wait-on http://localhost:4200 && npm run cypress:run",
    "cypress:test": "start-server-and-test cypress:start http://localhost:4200 cypress:run"
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^8.0.0",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular/animations": "^21.2.7",
    "@angular/cdk": "^21.2.5",
    "@angular/common": "^21.2.7",
    "@angular/compiler": "^21.2.7",
    "@angular/core": "^21.1.1",
    "@angular/forms": "^21.2.7",
    "@angular/material": "^21.2.5",
    "@angular/material-luxon-adapter": "^21.2.5",
    "@angular/material-moment-adapter": "^21.2.5",
    "@angular/platform-browser": "^21.2.7",
    "@angular/platform-browser-dynamic": "^21.2.7",
    "@angular/router": "^21.2.7",
    "@messageformat/core": "^3.3.0",
    "@ngneat/dialog": "^5.2.1",
    "@ngneat/overview": "^8.1.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/signals": "^21.1.0",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@ngx-formly/bootstrap": "^7.1.0",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^10.56.0",
    "@zxing/browser": "0.1.5",
    "@zxing/library": "^0.21.0",
    "@zxing/ngx-scanner": "^21.0.0",
    "angular-auth-oidc-client": "^21.0.1",
    "angular-oauth2-oidc": "^21.0.0",
    "axios": "^1.7.9",
    "blob-util": "^2.0.2",
    "bootstrap": "^5.3.3",
    "dayjs": "^1.11.11",
    "heic2any": "^0.0.4",
    "html-to-image": "^1.11.11",
    "jsbarcode": "^3.12.3",
    "luxon": "^3.4.4",
    "magic-bytes.js": "^1.10.0",
    "material-symbols": "^0.18.0",
    "moment": "^2.30.1",
    "ng-http-caching": "^22.0.1",
    "ng-qrcode": "^21.0.0",
    "ng-simple-state": "^21.1.4",
    "ng-table-virtual-scroll": "^1.6.1",
    "ngx-barcode6": "^1.21.1",
    "ngx-extended-pdf-viewer": "^25.6.4",
    "ngx-mat-select-search": "^8.0.6",
    "ngx-skeleton-loader": "^13.0.0",
    "ngx-spinner": "^19.0.0",
    "ngx-toastr": "^19.1.0",
    "ngx-translate-messageformat-compiler": "^7.0.0",
    "node-fetch": "^3.3.2",
    "rxjs": "~7.8.1",
    "signature_pad": "^5.0.2",
    "uuidv4": "^6.2.13",
    "xlsx": "^0.18.5"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.4.5",
    "@analogjs/vitest-angular": "^2.4.5",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.1.1",
    "@angular/cli": "^21.1.1",
    "@angular/compiler-cli": "^21.2.7",
    "@bartholomej/ngx-translate-extract": "^8.0.2",
    "@ngx-formly/schematics": "^7.1.0",
    "@types/imap": "^0.8.40",
    "@types/jasmine": "~5.1.4",
    "@types/luxon": "^3.4.2",
    "@types/node": "^25.5.2",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "autoprefixer": "^10.4.19",
    "cypress": "latest",
    "eslint": "^9.3.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "imap": "^0.8.17",
    "jasmine-core": "^5.1.2",
    "jasmine-spec-reporter": "~7.0.0",
    "jsdom": "^29.0.2",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ng-openapi-gen": "^1.0.5",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.4.38",
    "prettier": "^3.2.5",
    "prettier-eslint": "^16.3.0",
    "prettier-plugin-tailwindcss": "^0.5.14",
    "start-server-and-test": "^2.0.3",
    "tailwindcss": "^3.4.3",
    "ts-node": "~10.9.2",
    "tslib": "^2.6.2",
    "typescript": "~5.9.2",
    "vitest": "^4.1.4"
  }
}